/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPPARTYTYPE } from './IAPPARTYTYPE';
import {
    IAPPARTYTYPEFromJSON,
    IAPPARTYTYPEFromJSONTyped,
    IAPPARTYTYPEToJSON,
} from './IAPPARTYTYPE';
import type { IAPPRODUCTCODE } from './IAPPRODUCTCODE';
import {
    IAPPRODUCTCODEFromJSON,
    IAPPRODUCTCODEFromJSONTyped,
    IAPPRODUCTCODEToJSON,
} from './IAPPRODUCTCODE';
import type { PaymentDetailsCashTransferViewModel } from './PaymentDetailsCashTransferViewModel';
import {
    PaymentDetailsCashTransferViewModelFromJSON,
    PaymentDetailsCashTransferViewModelFromJSONTyped,
    PaymentDetailsCashTransferViewModelToJSON,
} from './PaymentDetailsCashTransferViewModel';
import type { PaymentDetailsLumpSumViewModel } from './PaymentDetailsLumpSumViewModel';
import {
    PaymentDetailsLumpSumViewModelFromJSON,
    PaymentDetailsLumpSumViewModelFromJSONTyped,
    PaymentDetailsLumpSumViewModelToJSON,
} from './PaymentDetailsLumpSumViewModel';
import type { PaymentDetailsPayerOptionViewModel } from './PaymentDetailsPayerOptionViewModel';
import {
    PaymentDetailsPayerOptionViewModelFromJSON,
    PaymentDetailsPayerOptionViewModelFromJSONTyped,
    PaymentDetailsPayerOptionViewModelToJSON,
} from './PaymentDetailsPayerOptionViewModel';
import type { PaymentDetailsRecurringContributionViewModel } from './PaymentDetailsRecurringContributionViewModel';
import {
    PaymentDetailsRecurringContributionViewModelFromJSON,
    PaymentDetailsRecurringContributionViewModelFromJSONTyped,
    PaymentDetailsRecurringContributionViewModelToJSON,
} from './PaymentDetailsRecurringContributionViewModel';
import type { PaymentDetailsRegularWithdrawalViewModel } from './PaymentDetailsRegularWithdrawalViewModel';
import {
    PaymentDetailsRegularWithdrawalViewModelFromJSON,
    PaymentDetailsRegularWithdrawalViewModelFromJSONTyped,
    PaymentDetailsRegularWithdrawalViewModelToJSON,
} from './PaymentDetailsRegularWithdrawalViewModel';
import type { PaymentDetailsShouldShowPayeesViewModel } from './PaymentDetailsShouldShowPayeesViewModel';
import {
    PaymentDetailsShouldShowPayeesViewModelFromJSON,
    PaymentDetailsShouldShowPayeesViewModelFromJSONTyped,
    PaymentDetailsShouldShowPayeesViewModelToJSON,
} from './PaymentDetailsShouldShowPayeesViewModel';
import type { PaymentDetailsUnitTransferViewModel } from './PaymentDetailsUnitTransferViewModel';
import {
    PaymentDetailsUnitTransferViewModelFromJSON,
    PaymentDetailsUnitTransferViewModelFromJSONTyped,
    PaymentDetailsUnitTransferViewModelToJSON,
} from './PaymentDetailsUnitTransferViewModel';

/**
 * 
 * @export
 * @interface PaymentDetailsViewModel
 */
export interface PaymentDetailsViewModel {
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsViewModel
     */
    partyId: number;
    /**
     * 
     * @type {IAPPARTYTYPE}
     * @memberof PaymentDetailsViewModel
     */
    partyType: IAPPARTYTYPE;
    /**
     * 
     * @type {PaymentDetailsLumpSumViewModel}
     * @memberof PaymentDetailsViewModel
     */
    lumpSum?: PaymentDetailsLumpSumViewModel;
    /**
     * 
     * @type {PaymentDetailsRecurringContributionViewModel}
     * @memberof PaymentDetailsViewModel
     */
    recurringContribution?: PaymentDetailsRecurringContributionViewModel;
    /**
     * 
     * @type {PaymentDetailsUnitTransferViewModel}
     * @memberof PaymentDetailsViewModel
     */
    unitTransfer?: PaymentDetailsUnitTransferViewModel;
    /**
     * 
     * @type {PaymentDetailsRegularWithdrawalViewModel}
     * @memberof PaymentDetailsViewModel
     */
    regularWithdrawal?: PaymentDetailsRegularWithdrawalViewModel;
    /**
     * 
     * @type {PaymentDetailsCashTransferViewModel}
     * @memberof PaymentDetailsViewModel
     */
    cashTransfer?: PaymentDetailsCashTransferViewModel;
    /**
     * 
     * @type {Array<PaymentDetailsPayerOptionViewModel>}
     * @memberof PaymentDetailsViewModel
     */
    payerOptions: Array<PaymentDetailsPayerOptionViewModel>;
    /**
     * 
     * @type {Array<PaymentDetailsPayerOptionViewModel>}
     * @memberof PaymentDetailsViewModel
     */
    financialContributorOptions: Array<PaymentDetailsPayerOptionViewModel>;
    /**
     * 
     * @type {PaymentDetailsShouldShowPayeesViewModel}
     * @memberof PaymentDetailsViewModel
     */
    shouldShowThirdPartyPayeeOption: PaymentDetailsShouldShowPayeesViewModel;
    /**
     * 
     * @type {Array<PaymentDetailsPayerOptionViewModel>}
     * @memberof PaymentDetailsViewModel
     */
    thirdPartyPayeeOptions: Array<PaymentDetailsPayerOptionViewModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentDetailsViewModel
     */
    isComplete: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentDetailsViewModel
     */
    disablePersonalDetails?: boolean;
    /**
     * 
     * @type {IAPPRODUCTCODE}
     * @memberof PaymentDetailsViewModel
     */
    productCode?: IAPPRODUCTCODE;
}

/**
 * Check if a given object implements the PaymentDetailsViewModel interface.
 */
export function instanceOfPaymentDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "partyId" in value;
    isInstance = isInstance && "partyType" in value;
    isInstance = isInstance && "payerOptions" in value;
    isInstance = isInstance && "financialContributorOptions" in value;
    isInstance = isInstance && "shouldShowThirdPartyPayeeOption" in value;
    isInstance = isInstance && "thirdPartyPayeeOptions" in value;
    isInstance = isInstance && "isComplete" in value;

    return isInstance;
}

export function PaymentDetailsViewModelFromJSON(json: any): PaymentDetailsViewModel {
    return PaymentDetailsViewModelFromJSONTyped(json, false);
}

export function PaymentDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partyId': json['PartyId'],
        'partyType': IAPPARTYTYPEFromJSON(json['PartyType']),
        'lumpSum': !exists(json, 'LumpSum') ? undefined : PaymentDetailsLumpSumViewModelFromJSON(json['LumpSum']),
        'recurringContribution': !exists(json, 'RecurringContribution') ? undefined : PaymentDetailsRecurringContributionViewModelFromJSON(json['RecurringContribution']),
        'unitTransfer': !exists(json, 'UnitTransfer') ? undefined : PaymentDetailsUnitTransferViewModelFromJSON(json['UnitTransfer']),
        'regularWithdrawal': !exists(json, 'RegularWithdrawal') ? undefined : PaymentDetailsRegularWithdrawalViewModelFromJSON(json['RegularWithdrawal']),
        'cashTransfer': !exists(json, 'CashTransfer') ? undefined : PaymentDetailsCashTransferViewModelFromJSON(json['CashTransfer']),
        'payerOptions': ((json['PayerOptions'] as Array<any>).map(PaymentDetailsPayerOptionViewModelFromJSON)),
        'financialContributorOptions': ((json['FinancialContributorOptions'] as Array<any>).map(PaymentDetailsPayerOptionViewModelFromJSON)),
        'shouldShowThirdPartyPayeeOption': PaymentDetailsShouldShowPayeesViewModelFromJSON(json['ShouldShowThirdPartyPayeeOption']),
        'thirdPartyPayeeOptions': ((json['ThirdPartyPayeeOptions'] as Array<any>).map(PaymentDetailsPayerOptionViewModelFromJSON)),
        'isComplete': json['IsComplete'],
        'disablePersonalDetails': !exists(json, 'DisablePersonalDetails') ? undefined : json['DisablePersonalDetails'],
        'productCode': !exists(json, 'ProductCode') ? undefined : IAPPRODUCTCODEFromJSON(json['ProductCode']),
    };
}

export function PaymentDetailsViewModelToJSON(value?: PaymentDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PartyId': value.partyId,
        'PartyType': IAPPARTYTYPEToJSON(value.partyType),
        'LumpSum': PaymentDetailsLumpSumViewModelToJSON(value.lumpSum),
        'RecurringContribution': PaymentDetailsRecurringContributionViewModelToJSON(value.recurringContribution),
        'UnitTransfer': PaymentDetailsUnitTransferViewModelToJSON(value.unitTransfer),
        'RegularWithdrawal': PaymentDetailsRegularWithdrawalViewModelToJSON(value.regularWithdrawal),
        'CashTransfer': PaymentDetailsCashTransferViewModelToJSON(value.cashTransfer),
        'PayerOptions': ((value.payerOptions as Array<any>).map(PaymentDetailsPayerOptionViewModelToJSON)),
        'FinancialContributorOptions': ((value.financialContributorOptions as Array<any>).map(PaymentDetailsPayerOptionViewModelToJSON)),
        'ShouldShowThirdPartyPayeeOption': PaymentDetailsShouldShowPayeesViewModelToJSON(value.shouldShowThirdPartyPayeeOption),
        'ThirdPartyPayeeOptions': ((value.thirdPartyPayeeOptions as Array<any>).map(PaymentDetailsPayerOptionViewModelToJSON)),
        'IsComplete': value.isComplete,
        'DisablePersonalDetails': value.disablePersonalDetails,
        'ProductCode': IAPPRODUCTCODEToJSON(value.productCode),
    };
}

